export default "/assets/47bee881316cc24ed9305be7275217fc.png";